import BlockType from '../enums/blockType';
import { Block } from '../types/shared/blocksV3';

function getBlock(blocks: Block[], id: string | null): Block | null {
	const deckboxes = blocks.filter((blk) => blk.type == BlockType.DECKBOX);
	const landings = deckboxes.flatMap((dk) => dk.landings);
	const stairs = deckboxes.flatMap((dk) => dk.stairs);
	const bumpouts = deckboxes.flatMap((dk) => dk.bumpouts);

	const block = [...deckboxes, ...landings, ...stairs, ...bumpouts].find(
		(blk) => blk?.id == id
	);

	return block ? block : null;
}

export default getBlock;
